import { useRequest } from 'features/request/useRequest';

import { useCallback, useMemo } from 'react';
import { useDispatch } from 'react-redux';

import { otherCostTypeRemoveGql } from '../CatalogOthersTypeQueries';

type TRemoveTypeProps = {
    onSuccess: () => void;
};
export const useRemoveType = ({ onSuccess }: TRemoveTypeProps) => {
    const dispatch = useDispatch();

    const [, , , request] = useRequest({
        requestId: 'createCatalogType',
        query: otherCostTypeRemoveGql,
        withEffect: false,
        dependenciesUpdater: onSuccess,
    });

    const handleRemove = useCallback(
        (typeId: number) => {
            dispatch(request({ catalogOtherCostTypeId: typeId }));
        },
        [dispatch, request],
    );

    return useMemo(() => handleRemove, [handleRemove]);
};
